import { TTableStructureFilter } from '../../../../../../ui/EasTable/types';

export type TEditShopifyStoreDialogProps = {
	open: boolean;
	storeId: number | null;
	onClose: () => void;
};

export type TEditShopifyStoreFormValues = {
	// Application
	enabled: boolean;
	export_period: number;
	// EAS params
	immediately_process_paid_orders: boolean;
	weight_unit: EWeightUnit;
	act_as_disclosed_agent: boolean;
	hs6p_received: string;
	type_of_goods: ETypeOfGoods;
	reduced_tbe_vat_group: boolean;
	seller_registration_country: string;
	originating_country: string;
	location_warehouse_country: string;
	order_tags_enable: boolean;
	handle_ireland_as_ioss: boolean;
	swisspost_full_ddp_delivery_customs_description: boolean;
	// Sales channels
	sales_channels_enabled: boolean;
	sales_channels_selected_will_be_processed: number[];
};

export enum ETypeOfGoods {
	GOODS = 'goods',
	TBE = 'tbe',
}

export enum EWeightUnit {
	GRAMS = 'grams',
	KILOGRAMS = 'kilograms',
	OUNCES = 'ounces',
	POUNDS = 'pounds',
}
export const TYPE_OF_GOODS_FILTER: TTableStructureFilter = [
	[ETypeOfGoods.GOODS, 'Goods'],
	[ETypeOfGoods.TBE, 'TBE'],
];
export const WEIGHT_UNIT_FILTER: TTableStructureFilter = [
	[EWeightUnit.GRAMS, 'Grams (g)'],
	[EWeightUnit.KILOGRAMS, 'Kilograms (kg)'],
	[EWeightUnit.OUNCES, 'Ounces (oz)'],
	[EWeightUnit.POUNDS, 'Pounds (lb)'],
];
export const WEIGHT_UNIT_OPTIONS: { value: string; label: string }[] = [
	{ value: EWeightUnit.GRAMS, label: 'Grams (g)' },
	{ value: EWeightUnit.KILOGRAMS, label: 'Kilograms (kg)' },
	{ value: EWeightUnit.OUNCES, label: 'Ounces (oz)' },
	{ value: EWeightUnit.POUNDS, label: 'Pounds (lb)' },
];

export const TYPE_OF_GOODS_OPTIONS: { value: ETypeOfGoods; label: string }[] = [
	{ value: ETypeOfGoods.GOODS, label: 'Goods' },
	{ value: ETypeOfGoods.TBE, label: 'TBE' },
];

export const SALES_CHANNELS_HINT =
	'By default if sales channel marked for skipping then all orders from that channel will be skiped for processing. If sales channed added to the list, then orders will be processed as normal orders and customer considered as tax liable.';
